@if (item) {
  <form [formGroup]="form">
    <ion-card class="ion-no-padding ion-no-margin">
      <ion-card-content class="ion-no-padding">
        <ion-list lines="full" class="ion-no-padding">
          <ion-item>
            <ion-label position="floating">Name</ion-label>
            <ion-input formControlName="name" (ionBlur)="updateName()"></ion-input>
          </ion-item>
          <ion-item lines="full">
            <ion-label>Keg</ion-label>
            @if (item.keg) {
              <ion-button (click)="openKeg(item.keg!)" fill="solid" color="light" slot="end">
                {{ item.keg.name }} {{ item.keg.beverage?.name }}
              </ion-button>
            }
            @if (item.keg && item.id) {
              <ion-button (click)="removeKegFromTap(item.id)" slot="end" fill="clear" shape="round" color="danger" size="default">
                <ion-icon size="small" slot="icon-only" name="trash-outline">
                </ion-icon>
              </ion-button>
            }
            @if (!item.keg && item.id) {
              <ion-button (click)="openKegChooser(item)" slot="end" fill="clear" shape="round" color="success" size="default">
                <ion-icon size="small" slot="icon-only" name="add-circle-outline">
                </ion-icon>
              </ion-button>
            }
          </ion-item>
          @if (item && useWashing) {
            <ion-item lines="none">
              <ion-label>Latest cleaning</ion-label>
              @if (!!cleanDate) {
                <ion-datetime-button slot="end" datetime="cleanDate"></ion-datetime-button>
              }
              @if (!item.cleanDate) {
                <ion-button (click)="setDefaultCleanDate()" slot="end" fill="clear" shape="round" color="success" size="default">
                  <ion-icon size="small" slot="icon-only" name="add-circle-outline"></ion-icon>
                </ion-button>
              }
              @if (item.cleanDate) {
                <ion-button (click)="deleteCleanDate()" slot="end" fill="clear" shape="round" color="danger" size="default">
                  <ion-icon size="small" slot="icon-only" name="trash-outline">
                  </ion-icon>
                </ion-button>
              }
              <ion-modal [keepContentsMounted]="true">
                <ng-template>
                  @if (cleanDate) {
                    <ion-datetime presentation="date" [value]="cleanDate" size="cover" id="cleanDate"
                      (ionChange)="setCleanDate($event)" showDefaultButtons="true">
                      <span slot="title">Latest Clean Date</span>
                    </ion-datetime>
                  }
                </ng-template>
              </ion-modal>
            </ion-item>
          }
        </ion-list>
      </ion-card-content>
    </ion-card>
    <div class="ion-padding-top">
      <ion-text color="medium">
        <h6>Monitors</h6>
      </ion-text>
      <ion-card class="ion-no-padding ion-no-margin">
        <ion-card-content class="ion-no-padding">
          <ion-list lines="full" class="ion-no-padding">
            @if (!!allPlaato2s) {
              <ion-item>
                <ion-label>Plaato</ion-label>
                @if (!!plaato2) {
                  <span>{{ plaato2.name }}</span>
                }
                @if (plaato2 && item.id) {
                  <ion-button (click)="removePlaato2FromTap(item.id)" slot="end" fill="clear" shape="round" color="danger" size="default">
                    <ion-icon size="small" slot="icon-only" name="trash-outline">
                    </ion-icon>
                  </ion-button>
                }
                @if (!plaato2) {
                  <ion-button (click)="openPlaato2Modal(item)" slot="end" fill="clear" shape="round" color="success" size="default">
                    <ion-icon size="small" slot="icon-only" name="add-circle-outline">
                    </ion-icon>
                  </ion-button>
                }
              </ion-item>
            }
            @if (!!allKegtrons) {
              <ion-item>
                <ion-label>Kegtron</ion-label>
                @if (!!kegtron) {
                  <span>{{ kegtron.name }}</span>
                }
                @if (kegtron && item.id) {
                  <ion-button (click)="removeKegtronFromTap(item.id)" slot="end" fill="clear" shape="round" color="danger" size="default">
                    <ion-icon size="small" slot="icon-only" name="trash-outline">
                    </ion-icon>
                  </ion-button>
                }
                @if (!kegtron) {
                  <ion-button (click)="openKegtronModal(item)" slot="end" fill="clear" shape="round" color="success" size="default">
                    <ion-icon size="small" slot="icon-only" name="add-circle-outline">
                    </ion-icon>
                  </ion-button>
                }
              </ion-item>
            }
            @if (!!allCustomKegMons) {
              <ion-item>
                <ion-label>Custom Keg Monitor</ion-label>
                @if (customKegMon) {
                  <span>{{ customKegMon.name }}</span>
                }
                @if (customKegMon && item.id) {
                  <ion-button (click)="removeCustomKegMonFromTap(item.id)" slot="end" fill="clear" shape="round" color="danger" size="default">
                    <ion-icon size="small" slot="icon-only" name="trash-outline">
                    </ion-icon>
                  </ion-button>
                }
                @if (!customKegMon) {
                  <ion-button (click)="openCustomKegMonModal(item)" slot="end" fill="clear" shape="round" color="success" size="default">
                    <ion-icon size="small" slot="icon-only" name="add-circle-outline">
                    </ion-icon>
                  </ion-button>
                }
              </ion-item>
            }
            @if (item.plaatoId) {
              <ion-item>
                <ion-label>Display Plaato Keg temp</ion-label>
                <ion-toggle label="Display Plaato Keg temp" formControlName="dispTemp" color="success"
                (ionChange)="updateDisplayPlaatoTemp()" slot="end"></ion-toggle>
              </ion-item>
            }
          </ion-list>
        </ion-card-content>
      </ion-card>
    </div>
  </form>
}
